__turbopack_context__.v({
  "buttonLockWrap": "uOashG_buttonLockWrap",
  "container": "uOashG_container",
  "content": "uOashG_content",
  "iconLocked": "uOashG_iconLocked",
  "iconUnlocked": "uOashG_iconUnlocked",
  "iconWrap": "uOashG_iconWrap",
  "inner": "uOashG_inner",
  "isCurrent": "uOashG_isCurrent",
  "isHoverSuppressed": "uOashG_isHoverSuppressed",
  "item": "uOashG_item",
  "link": "uOashG_link",
  "list": "uOashG_list",
  "textWrap": "uOashG_textWrap",
});
